import { FC } from "react";
import styles from "./ClubCard.module.scss";
import { Button } from "../ui";
import { useNavigate } from "react-router-dom";

export interface IClubCard {
  id: number;
  name: string;
  image: string;
}

export const ClubCard: FC<IClubCard> = ({ name, image, id }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card}>
      <h3 className={styles.card__title}>{name}</h3>
      <div className={styles.card__img}>
        <img
          src={image ? image : "https://placehold.co/400"}
          alt={name}
          onError={(e) => {
            e.currentTarget.src = "https://placehold.co/400";
          }}
        />
      </div>
      <div className={styles.card__btn}>
        <Button onClick={() => navigate(`/clubs/#${id}`)}>Besuchen</Button>
      </div>
    </div>
  );
};
